<template>
	<div v-loading="loading" style="position: relative;flex: 1;height: 100%;overflow: hidden;">
		<div style="width: 100%;height: 100%;padding: 15px;overflow-x: hidden;overflow-y: auto;">
			<!-- 顶部查询 -->
			<div style="border: 1px solid #ccc;background: #f7f7f7;border-radius: 5px;">
				<div class="base_inquire" style="padding: 20px 30px 5px;">
					<div class="b_item">
						<span class="b_label">开始日期：</span>
						<el-date-picker
							v-model="search_startDate"
							:editable="false"
							:clearable="false"
							placeholder="开始日期"
							type="date"
							value-format="yyyy-MM-dd"
							@change="handleSearchStartDateChange"
						>
						</el-date-picker>
					</div>
					
					<div class="b_item">
						<span class="b_label">结束日期：</span>
						<el-date-picker
							v-model="search_endDate"
							:editable="false"
							:clearable="false"
							placeholder="结束日期"
							type="date"
							value-format="yyyy-MM-dd"
							@change="handleSearchEndDateChange"
						>
						</el-date-picker>
					</div>
					
					<div class="b_item">
						<span class="b_label">患者姓名：</span>
						<el-input v-model="search_name" class="b_inp" placeholder="患者姓名"></el-input>
					</div>
					
					<div class="b_item">
						<span class="b_label">患者账号：</span>
						<el-input v-model="search_code" class="b_inp" placeholder="患者账号"></el-input>
					</div>
					
					<div class="b_item">
						<span class="b_label">机构名称：</span>
						<el-input v-model="search_firmName" class="b_inp" placeholder="机构名称"></el-input>
					</div>
			
					<el-button type="primary" @click="handleSearchClick">查询</el-button>
				</div>
			</div>
			<!-- 顶部查询 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="code"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="phone"
						label="手机号"
					>
					</el-table-column>
					<el-table-column
						prop="firmName"
						label="所属机构"
					>
					</el-table-column>
					<el-table-column
						prop="createTime"
						label="注册时间"
					>
					</el-table-column>
					<el-table-column
						label="出勤天数"
					>
						<template slot-scope="scope">
							<el-button
								style="text-decoration: underline;"
								@click="handleAttendanceClick(scope.row)"
							>{{ scope.row.trainingNum }}</el-button>
						</template>
					</el-table-column>
					<el-table-column
						label="操作"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleViewClick(scope.row)"
							>查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 出勤天数弹框 -->
		<Attendance 
			v-model="attendance_display"
			:uid="attendance_uid"
		></Attendance>
		<!-- 出勤天数弹框 end -->
		
		<!-- 异常训练详情弹框 -->
		<abnormal-training-detail 
			v-model="detail_display" 
			:uid="detail_uid"
			:code="detail_code"
			:fid="detail_firmId"
		></abnormal-training-detail>
		<!-- 异常训练详情弹框 end -->
	</div>
</template>

<script>
	import Api from '../../../../api/index.js';
	import Attendance from './components/attendance.vue';
	import AbnormalTrainingDetail from './components/abnormal_training_detail.vue';
	import BaseMethods from '../../../../assets/js/base.js';
	import { mapState } from 'vuex';
	
	export default {
		mounted() {
			this.getData();
		},
		data() {
			return {
				loading: false,
				
				search_startDate: BaseMethods.getTime(new Date().getTime() - 15 * 24 * 60 * 60 * 1000),
				search_endDate: BaseMethods.getTime(new Date().getTime()),
				search_name: '',
				search_code: '',
				search_firmName: '',
				
				currentPage: 1,
				total: 0,
				tableData: [],
				
				attendance_display: false,
				attendance_uid: '',
				
				detail_display: false,
				detail_uid: '',
				detail_code: '',
				detail_firmId: ''
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			/******************** @Events *************************/
			// 切换查询时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 切换查询时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.getData();
			},
			// 切换页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			// 点击出勤天数
			handleAttendanceClick(data) {
				this.attendance_uid = data.id;
				this.attendance_display = true;
			},
			// 点击查看
			handleViewClick(data) {
				this.detail_uid = data.id;
				this.detail_code = data.code;
				this.detail_firmId = data.firmId;
				this.detail_display = true;
			},
			
			/******************** @Function *************************/
			// 获取列表数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = { 
					"dayNum": null,
					"endTime": that.search_endDate,
					"enterpriseName": that.search_firmName,
					"guideDoctorId": null,
					"limit": 10,
					"loginerCategory": that.authInfo.ucategory,
					"loginerEnterpriseId": that.authInfo.uenterpriseId,
					"pageNum": that.currentPage,
					"startTime": that.search_startDate,
					"type": null,
					"userCode": that.search_code,
					"userId": that.authInfo.uid,
					"username": that.search_name
				};
				Api.findAbnormalTrainingForUser(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let data = [];
						that.total = res.data.data.totalItems;
						res.data.data.data && res.data.data.data.forEach((v) => {
							data.push({
								id: v.userId || '',
								name: v.username || '',
								code: v.code || '',
								phone: v.phone || '',
								firmId: v.enterpriseId || '',
								firmName: v.enterpriseName || '',
								createTime: v.createTime || '',
								trainingNum: v.trainingNum || 0
							});
						});
						that.tableData = data;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				var startDate = new Date(this.search_startDate).getTime(),
					endDate = new Date(this.search_endDate).getTime();
				if (endDate < startDate) {
					this.search_startDate = this.search_endDate;
					this.$message({
						message: '结束时间不能小于开始时间',
						type: 'warning'
					});
				}
			}
		},
		components: {
			Attendance,
			AbnormalTrainingDetail
		}
	}
</script>

<style scoped>
</style>
